<template>
  <a-card :bordered="false" :loading="loading" v-if="loading"> Loading </a-card>
  <div class="m-position-relative" v-else>
    <a-card>
    <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
      <div v-if="id === null || id === undefined">
        <a-card class="m-wrong">
          <m-anim
            :options="notfound"
            class="anim"
            :height="getScreen ? 200 : 500"
            :width="getScreen ? 200 : 500"
          ></m-anim>
          <h3>Not Found</h3>
          <label
            >Return to the previous page and make the selection manifest
            again!</label
          >
          <a-button type="primary" block>
            <router-link :to="{ name: 'proyekrab' }">
              <a-icon type="rollback" />&nbsp; Return
            </router-link>
          </a-button>
        </a-card>
      </div>
      <div v-else>
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-card class="margin-bottom" :loading="loading">
              <div slot="title">Manifest Finance Simulation</div>

              <div v-if="data2.header" class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>RENCANA PENDANAAN OPERASIONAL DAN INVESTASI PT.INFOGLOBAL</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Tahun</span>
                    <span class="m-list-desc">{{
                      data2.header[0].jenis_anggaran?data2.header[0].jenis_anggaran:"-"
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Nama Simulasi</span>
                    <span class="m-list-desc">{{ data2.header[0].kode_cost_center?data2.header[0].kode_cost_center:"-" }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Catatan</span>
                    <span class="m-list-desc">{{ data2.header[0].nama_pekerjaan ? data2.header[0].nama_pekerjaan : "-" }}</span>
                  </li>
                </ul>
              </div>
            </a-card>
            <!-- <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Budget Details</h4>
                <TableSimulasi v-if="genColumn.length>0 && data2.tree.length > 0" :source="data2.tree" :column="genColumn" 
                  :datatree="tree" :listTahun="listThn" />
              </a-collapse-panel>
            </a-collapse> -->
          </a-col>
          
          <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
            <span slot="title">
              <a-icon type="reload" />&nbsp;History Status
            </span>

            <ul class="m-list-wrapper bordered">
              <li v-for="history in data2.notifikasi" :key="history.id_notifikasi">
                <div v-if="history.aksi === '1' || history.aksi === '3'">
                  <div class="m-display-flex space-between">
                    <h3 class="margin-remove m-list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
                    <Status :status="history.deskripsi" />
                  </div>
                  <span class="m-list-desc">{{moment(history.tgl_notif).format(getDateTimeFormat)}}</span>
                </div>
                <div v-else-if="history.aksi === '2' || history.aksi === '4'">
                  <div class="m-display-flex space-between">
                    <h3
                      class="margin-remove m-list-title"
                      v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                    >{{history.as_from}} | {{history.tlc_from}}</h3>
                    <h3 class="margin-remove m-list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
                    <Status :status="history.deskripsi" />
                  </div>
                  <span class="m-list-desc">{{moment(history.tgl_notif).format(getDateTimeFormat)}}</span>
                </div>
              </li>
            </ul>
          </a-modal>
        </a-row>
        <a-row>
        <!-- <TableSimulasi v-if="genColumn.length>0 && data2.tree.length > 0" :source="data2.tree" :column="genColumn" 
                  :datatree="tree" :listTahun="listThn" :allowtoEdit="false"/> -->
        <TableSimulasi v-if="genColumn.length>0" :source="data2.tree" :column="genColumn"
          :head="head" :datatree="data2.tree" :listTahun="listThn" :allowtoEdit="false" :urlExport="urlExport"/>
        </a-row>
      </div>
      <a-drawer
        title="Upload Document"
        placement="bottom"
        height="310"
        :closable="false"
        @close="onClose"
        :visible="uploadVisible"
      >
        <a-form :form="form">
          <a-form-item label="Document Description">
            <a-input
              v-decorator="['deskripsi', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Upload Document File">
            <a-upload
              :showUploadList="true"
              :fileList="push"
              :beforeUpload="beforeUpload"
              v-decorator="[
                'upload',
                { rules: [{ required: true }], valuePropName: 'push' },
              ]"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              block
              @click="handleNew"
              :loading="btnLoading"
              >Add</a-button
            >
          </a-form-item>
        </a-form>
      </a-drawer>
    </div>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import lottie from "vue-lottie";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";
import moment from "moment";
import notfound from "@/assets/anim/404.json";
import HandleRoute from "@/mixins/HandleRoute";
import TableSimulasi from "@/components/TableSimulation";
import _ from "lodash";

export default {
  name: "manifestSimulasiAnggaran",
  props: ["id", "thn"],
  components: { "m-anim": lottie, TableSimulasi, Status },
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    const columnModal = [
      {
        title: "Deskripsi",
        key: "deskripsi",
        scopedSlots: { customRender: "deskripsi" },
        sorter: (a, b) => a.jenis.length - b.jenis.length,
      },
      {
        title: "Tanggal Buat",
        key: "tanggal",
        dataIndex: "tanggal_buat",
        width: 150,
        sorter: (a, b) =>
          moment(a.tanggal_buat).unix() - moment(b.tanggal_buat).unix(),
      },
      {
        title: "Status",
        key: "status",
        width: 120,
        scopedSlots: { customRender: "status" },
        sorter: (a, b) => a.status.length - b.status.length,
      },
      {
        title: "Value",
        key: "value",
        align: "right",
        scopedSlots: { customRender: "value" },
        sorter: (a, b) => a.value - b.value,
      },
      {
        title: "Realisasi",
        key: "realization",
        align: "right",
        scopedSlots: { customRender: "realization" },
      },
    ];
    const columnRab = [
      {
        title: "Departement",
        key: "title",
        scopedSlots: { customRender: "dataTitle" },
      },
      {
        title: "Total Budget",
        key: "anggaran",
        dataIndex: "anggaran",
        scopedSlots: { customRender: "anggaran" },
      },
      {
        title: "Total Allocation",
        key: "pemakaian",
        dataIndex: "pemakaian",
        scopedSlots: { customRender: "pemakaian" },
      },
      {
        title: "Total Realization",
        key: "realisasi",
        dataIndex: "realisasi",
        scopedSlots: { customRender: "realization" },
      },
      {
        title: "Allocation Budget",
        key: "sisa",
        dataIndex: "sisa",
        scopedSlots: { customRender: "sisa" },
      },
      {
        title: "Realization Budget",
        key: "sisa_realisasi",
        dataIndex: "sisa_realisasi",
        scopedSlots: { customRender: "trealization" },
      },
    ];
    return {
      loading: true,
      loadingModal: true,
      btnLoading: false,
      notfound: { animationData: notfound, loop: true },
      data: {},
      data2: {},
      uploadVisible: false,
      push: [],
      search: "",
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      rabVisibleDtl: false,
      dataRabVisibleDtl: {
        title: "",
        data: {
          pengeluran: "",
        },
      },
      columnRab,
      columnModal,
      isRabExist: true,
      genColumn:[],
      listThn: {dtl :[],rekap:[]},
      tree: [],
      visibleHistory: false,
      head: {},
      urlExport: this.$serviceUrl + "simulasi/export"
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getDefaultDateFormat",
    ]),
    searchbox() {
      let data = this.dataRabVisibleDtl.data.pengeluaran;

      if (this.search) {
        data = _.filter(
          data,
          (value) =>
            (value.jenis ? value.jenis : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.status ? value.status : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.no ? value.no : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.value ? value.value : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            (value.realisasi ? value.realisasi : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            this.moment(value.tanggal_buat)
              .format(this.getDefaultDateFormat)
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      let totalallocation = 0;
      let totalrealisasi = 0;

      if (data) {
        data.forEach((list) => {
          totalallocation = totalallocation + parseFloat(list.value);
          totalrealisasi =
            totalrealisasi + parseFloat(list.realisasi ? list.realisasi : 0);
        });
      }

      return { data, totalallocation, totalrealisasi };
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  methods: {
    moment,
    async fetchManifest() {
      this.loading = true;
      // await axios({
      //   method: "get",
      //   url: this.$serviceUrl + "project",
      //   params: {
      //     tlc: this.getAuth.username,
      //     id_manifest: this.id,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     this.data = {
      //       header: response.data.header[0],
      //       dokumen_kontrak: response.data.dokumen_kontrak,
      //       informasi_rab: response.data.informasi_rab,
      //       total_rab: response.data.total,
      //       informasi_detail_kontrak: response.data.informasi_detail_kontrak,
      //       dokumen_closing: response.data.dokumen_closing,
      //       jenis: response.data.jenis,
      //     };

      //     let tBudget = 0;
      //     _.forEach(response.data.informasi_rab, (item) => {
      //       tBudget = tBudget + parseInt(item.anggaran);
      //     });

      //     if (tBudget == 0) {
      //       this.isRabExist = false;
      //     } else {
      //       this.isRabExist = true;
      //     }

      //     this.loading = false;
      //   })
      //   .catch((err) => {
      //     if (!err.response) {
      //       let responses = Object.assign({}, err.response.data);
      //       this.displayMessageValue("error", responses);
      //       this.$router.go(-1);
      //     } else {
      //       this.displayMessage("denied-manifest");
      //       this.$router.push({ name: "beranda" });
      //     }
      //   });

        await axios({
        method: "get",
        url: this.$serviceUrl + "simulasi/manifest",
        params: {
          tlc: this.getAuth.username,
          tahun : parseInt(this.thn),
          jenis: "manifest",
          id_simulasi: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data2 = response.data;
          this.head.year = this.data2.tahun[0];
          this.head.simulation_nm = this.data2.simulation_nm;
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
        this.generateColumn();
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDokumen(file) {
      const url = this.$serviceUrl + file.url;
      window.open(url, "_blank");
    },
    showDrawer() {
      this.uploadVisible = true;
    },
    onClose() {
      this.uploadVisible = false;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleNew() {
      this.confirmMessage("confirm-save");
    },
    handleNewProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.btnLoading = false;
          this.displayMessage("form-warning");
          return;
        }

        let addData = new FormData();
        addData.append("kode_proyek", this.id);
        addData.append("deskripsi_doc", values.deskripsi);
        addData.append("tlc", this.getAuth.username);
        addData.append("file_transfer", this.push[0]);

        this.btnLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "project/doc_closing",
          processData: false,
          data: addData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.btnLoading = false;
            this.uploadVisible = false;
            this.fetchManifest();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleRemove(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "project/doc_closing",
        processData: false,
        data: {
          id_project_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("refresh", true);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.confirmMessage("confirm-close");
    },
    close() {
      if (this.data.dokumen_closing.length >= 1) {
        const serviceUrl = this.$serviceUrl,
          auth = {
            username: this.getAuth.username,
            password: this.getAuth.password,
            apikey: this.getAuth.apikey,
          },
          data = new FormData();

        data.append("tlc", auth.username);
        data.append("kode_proyek", this.id);
        axios({
          method: "post",
          url: serviceUrl + "project/closing",
          processData: false,
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-close-project");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      } else {
        this.displayMessage("warning-emptyDoc");
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    hideModal() {
      this.toggleBodyClass("removeClass", "scrollDisable");
      this.rabVisibleDtl = false;
    },
    visibleDtlToggle(item) {
      this.loadingModal = true;
      this.toggleBodyClass("addClass", "scrollDisable");

      axios({
        method: "get",
        url: this.$serviceUrl + "project/detil_rab",
        params: {
          kode_proyek: this.id,
          allocation: item.toLowerCase(),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let items = {
            title: item,
            data: JSON.parse(JSON.stringify(response.data)),
          };
          this.dataRabVisibleDtl = items;
          this.loadingModal = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
      this.rabVisibleDtl = true;
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    generateColumn(){
      let rangethn = [];
      let lop = 0;
      var gencolm = [];

      //colom title item / cost center
      gencolm = [{
          slots: { title: 'customTitleMain'},
          key: 'name',
          width: 320,
          fixed: "left",
          showcolumn:"",
          scopedSlots: { customRender: "name" }
        }];
      //colom header all tahun
      gencolm.push({
          key: 'alltahun',
          slots: { title: 'customTitleAllTahun' },
          scopedSlots: { customRender: 'alltahun' },
          dataIndex: 'rangetahun',
          align: "left",
          width:150,
          children: []
        }
      );
      this.data2.tahun.forEach((item) => {
        rangethn[lop]=item;

        //detil
        var dtljson = {
          title:  "Year " + item,
          scopedSlots: { customRender: 'tahun' },
          className: "unhide header th"+item,
          width:150,
          children: [
            {
              title: 'Jan',
              width: 150,
              dataIndex: 'bln'+item+'1',
              key: 'bln'+item+'1',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: ('dtlitem01') }
            },
            {
              title: 'Feb',
              width:150,
              dataIndex: 'bln'+item+'2',
              key: 'bln'+item+'2',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem02' }
            },
            {
              title: 'Mar',
              width:150,
              dataIndex: 'bln'+item+'3',
              key: 'bln'+item+'3',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem03' }
            },
            {
              title: 'Apr',
              width:150,
              dataIndex: 'bln'+item+'4',
              key: 'bln'+item+'4',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem04' }
            },
            {
              title: 'Mei',
              width:150,
              dataIndex: 'bln'+item+'5',
              key: 'bln'+item+'5',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem05' }
            },
            {
              title: 'Jun',
              width:150,
              dataIndex: 'bln'+item+'6',
              key: 'bln'+item+'6',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem06' }
            },
            {
              title: 'Jul',
              width:150,
              dataIndex: 'bln'+item+'7',
              key: 'bln'+item+'7',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem07' }
            },
            {
              title: 'Agu',
              width:150,
              dataIndex: 'bln'+item+'8',
              key: 'bln'+item+'8',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem08' }
            },
            {
              title: 'Sep',
              width:150,
              dataIndex: 'bln'+item+'9',
              key: 'bln'+item+'9',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem09' }
            },
            {
              title: 'Okt',
              width:150,
              dataIndex: 'bln'+item+'10',
              key: 'bln'+item+'10',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem10' }
            },
            {
              title: 'Nop',
              width:150,
              dataIndex: 'bln'+item+'11',
              key: 'bln'+item+'11',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem11' }
            },
            {
              title: 'Des',
              width:150,
              dataIndex: 'bln'+item+'12',
              key: 'bln'+item+'12',
              align: 'right',
              className: "unhide th"+item,
              scopedSlots: { customRender: 'dtlitem12' }
            },
          ],
        };

        //rekap
        var dtljson2 = {
          title: "Year " + item,
          className: "hide header th"+item+"rekap kolom",
          width:150,
          children: [
            {
              title: 'Sub Total',
              dataIndex: 'rekap'+item,
              key: 'rekap'+item,
              align: 'right',
              width: 150,
              float:"right",
              className: "hide th"+item+"rekap kolom",
              scopedSlots: { customRender: 'dtlitemrekap' }
            },
          ]}
        ;


          //push ke variable generate top root
        gencolm[1].children.push(dtljson);
        gencolm[1].children.push(dtljson2);
        lop++
      });

      //rekap allrange tahun
      var rkpjson = {
          slots: { title: 'customTitleTahun' },
          scopedSlots: { customRender: 'tahun' },
          className: "hide alltahun",
          children: [
            // {
            //   title: 'Grand Total',
            //   dataIndex: 'rekapalltahun',
            //   key: 'rekapalltahun',
            //   align: 'right',
            //   float: "left",
            //   width: 300,
            //   className: "hide alltahun",
            //   scopedSlots: { customRender: 'dtlitemrekap' }
            // },
          ],
        };
      gencolm[1].children.push(rkpjson);
      this.listThn.dtl=rangethn;
      this.listThn.rekap=rangethn;
      this.genColumn = gencolm;
    },
  },
  mounted() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageClose", this.close);
    Event.$on("confirmMessageReturn", this.handleNewProcess);
  },
  beforeDestroy() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageClose", this.close);
    Event.$off("confirmMessageReturn", this.handleNewProcess);
  },
};
</script>
<style lang="less">
.ant {
  &-modal {
    top: 12px !important;
  }
  &-table {
    &-footer {
      padding: 0;
    }
  }
  &-list-item {
    &-content {
      margin-bottom: 0 !important;
    }
  }
}
.m-price-total {
  margin: 0 !important;
  text-align: right;

  &.mobile {
    .ant-statistic-content {
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.textbold {
  font-weight: bold;
}
</style>